'use client';

import React from 'react';
import { Props as SpacerProps } from 'components/commercetools-ui/organisms/spacer';
import { TasticProps } from '../types';
import ScrollToTopButton from 'components/commercetools-ui/atoms/scroll-to-top';

const ScrollToTopTastic = ({}: TasticProps<SpacerProps>) => {
  return <ScrollToTopButton />;
};

export default ScrollToTopTastic;
